import { FiltersContextProvider } from '../../context/filters';
import AiAgentChatWidget from '../AiAgentChatWidget';
import * as s from './styles';
import * as tp from './types';

import Sidebar from '../Sidebar';
import sidebarItems from '../Sidebar/items/sidebarItems';

export const ContentManager = ({
  navbar = false,
  permissionProfile = 'tenant',
  Component,
}: tp.ContentManager) => {
  const SidebarItemsManager = () => {
    switch (permissionProfile) {
      case 'tenant':
        return sidebarItems.tenantSidebarItems();
      case 'seller':
        return sidebarItems.tenantSidebarItems();
      case 'customer':
        return sidebarItems.tenantSidebarItems();
      case 'superadmin':
        return sidebarItems.superadminSidebarItems();
      default:
        return sidebarItems.tenantSidebarItems();
    }
  };

  const comp = (): JSX.Element => (
    <s.MainContainer>
      <Sidebar items={SidebarItemsManager()} />

      <s.MainViewContainer>
        <Component />
      </s.MainViewContainer>

      {permissionProfile !== 'superadmin' && <AiAgentChatWidget />}
    </s.MainContainer>
  );

  return navbar ? (
    <FiltersContextProvider>{comp()}</FiltersContextProvider>
  ) : (
    <s.MainViewContainer>
      <Component />
    </s.MainViewContainer>
  );
};

export default ContentManager;
